import { getAtsUrl } from '../../config';
import { HttpClient } from '../../controllers/http-client/http-client';
import { HttpClientOptions } from '../../controllers/http-client/http-client.interfaces';

const atsBaseUrl = getAtsUrl?.();

export class AtsHttpClient extends HttpClient {
  constructor(options?: HttpClientOptions) {
    super(atsBaseUrl, options);
  }
}
